import { render, staticRenderFns } from "./IcoAchievement.vue?vue&type=template&id=04610c98"
import script from "./IcoAchievement.vue?vue&type=script&lang=js"
export * from "./IcoAchievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports